import ProdutoGiftCardRequest from 'Modules/contacard/produto/product/ProdutoGiftCardRequest';
import ProdutoBoletoRequest from 'Modules/contacard/produto/product/ProdutoBoletoRequest';
import ProdutoContaBoletoRequest from 'Modules/contacard/produto/product/ProdutoContaBoletoRequest';
import ProdutoTedTefRequest from 'Modules/contacard/produto/product/ProdutoTedTefRequest';
import ProdutoTransferRequest from 'Modules/contacard/produto/product/ProdutoTransferRequest';
import ProdutoTransferAccountRequest from 'Modules/contacard/produto/product/ProdutoTransferAccountRequest';
import ProdutoRequest from 'Modules/contacard/produto/product/ProdutoRequest';
import ProdutoChipRequest from 'Modules/contacard/produto/product/ProdutoChipRequest';

export default {
  data: () => ({
    requestProduto: ProdutoRequest,
    requestGiftCard: ProdutoGiftCardRequest,
    requestBoleto: ProdutoBoletoRequest,
    requestContaBoleto: ProdutoContaBoletoRequest,
    requestPrdTedTef: ProdutoTedTefRequest,
    requestTransfer: ProdutoTransferRequest,
    requestAccountTransfer: ProdutoTransferAccountRequest,
    requestChip: ProdutoChipRequest,
  }),
  methods: {
    getProdutoRequestByCategory(category) {
      switch (category) {
        case 'TR':
          return this.requestTransfer;
        case 'GC':
          return this.requestGiftCard;
        case 'BO':
          return this.requestBoleto;
        case 'PC':
          return this.requestContaBoleto;
        case 'TE':
          return this.requestPrdTedTef;
        case 'TC':
          return this.requestAccountTransfer;
        case 'CP':
          return this.requestChip;
        default:
          return this.requestProduto;
      }
    },
    hasNotProductRequest(type) {
      return !['RO', 'OT', 'RT'].includes(type);
    },
  },
};
